export const menuLinks = [
	{ url: '/about/', title: 'About' },
	{ url: '/projects/', title: 'Projects' },
	// { url: '/art/', title: 'Art' },
	{ url: '/contacts/', title: 'Contacts' },
]

export const minorMenuLinks = [
	{ url: '/careers/', title: 'Careers' },
	{ url: '/faq/', title: 'Frequently Asked Questions' },
	{ url: 'https://research.typeform.com/to/d5SVcDHm', title: 'Fill out Our Brief' },
]

// Old menu links
// export const menuLinks = [
// 	{
// 		title: 'Services',
// 		children: [
// 			{
// 				url: '/services/exterior-rendering/',
// 				title: 'Exterior Rendering',
// 			},
// 			{
// 				url: '/services/interior-rendering/',
// 				title: 'Interior Rendering',
// 			},
// 			{
// 				url: '/services/architectural-animation/',
// 				title: 'Architectural Animation',
// 			},
// 			{
// 				url: '/services/architectural-virtual-reality/',
// 				title: 'Architectural Virtual Reality',
// 			},
// 		],
// 	},
// 	{ url: '/projects/', title: 'Projects' },
// 	{ url: '/about/', title: 'About' },
// 	{ url: '/blog/', title: 'Blog' },
// 	{ url: '/art/', title: 'Art' },
// 	{ url: '/contacts/', title: 'Contacts' },
// ]
